export const BACKEND = process.env.REACT_APP_BACKEND;
export const WEBHOOK = process.env.REACT_APP_WEBHOOK;
export const API_PERU_URL = process.env.REACT_APP_API_PERU_URL;
export const API_PERU_TOKEN = process.env.REACT_APP_API_PERU_TOKEN;